import Skeleton from "react-loading-skeleton";

const DataTable = ({ columns, rows, loading, emptyMessage = "No data found" }) => {
  if (loading) {
    return (
      <div className="dashboard-card">
        <Skeleton count={6} height={40} />
      </div>
    );
  }

  if (!rows?.length) {
    return (
      <div className="dashboard-card">
        <p style={{ textAlign: "center", color: "var(--dash-muted)", margin: 0 }}>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="dashboard-table-wrap">
      <table className="dashboard-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row._key || row.id}>
              {columns.map((col) => (
                <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
